import address from "./dadataType";
export default {
  id: null,
  value: "",
  unrestricted_value: "",
  manual_input: false,
  data: address,
};
